import { Box, Button, Grid, IconButton, Stack, TextField, Typography, Divider } from '@mui/material'
import React, { useState } from 'react'
import { Save } from '@mui/icons-material'

const ObjetivosTab = ({ datos, setData, editable, handleUpdate }) => {
    const [form, setForm] = useState({
        factores_desarrollo: '',
        otras_organizaciones: '',
        resultados_socioeconomicos: '',
        perspectivas_desarrollo: '',
    });

    const handleAdd = (type) => {
        let newArr = [...datos[type], { [type.split('_')[0] != 'otras' ? type.split('_')[0] : type.split('_')[1]]: form[type] }];
        setData({ target: { name: [type], value: newArr } });
        setForm({ ...form, [type]: '' });
    };

    const removeEl = (index, type) => {
        let newArr = datos[type].filter((el, i) => i !== index);
        setData({ target: { name: type, value: newArr } });
    };

    return (
        <Box sx={{ m: 2 }}>
            {editable ? (
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                        <Typography variant="h6">Propósitos por los que surgió la empresa</Typography>
                        <TextField
                            fullWidth
                            name="propositos_surgimiento"
                            value={datos.propositos_surgimiento}
                            onChange={setData}
                            multiline
                            rows={4}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h6">Factores que han favorecido el desarrollo de la empresa</Typography>
                        <Stack direction="row" spacing={2}>
                            <TextField
                                fullWidth
                                value={form.factores_desarrollo}
                                onChange={(e) => setForm({ ...form, factores_desarrollo: e.target.value })}
                                label="Agregar factor"
                            />
                            <Button variant="contained" onClick={() => handleAdd('factores_desarrollo')}>Agregar</Button>
                        </Stack>
                        <ul>
                            {(datos.factores_desarrollo).map((factor, index) => (
                                <li key={index} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography>{factor.factores}</Typography>
                                    <IconButton onClick={() => removeEl(index, 'factores_desarrollo')}>X</IconButton>
                                </li>
                            ))}
                        </ul>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Typography variant="h6">Otras Organizaciones que han contribuido al fortalecimiento de la empresa</Typography>
                        <Stack direction="row" spacing={2}>
                            <TextField
                                fullWidth
                                value={form.otras_organizaciones}
                                onChange={(e) => setForm({ ...form, otras_organizaciones: e.target.value })}
                                label="Agregar organización"
                            />
                            <Button variant="contained" onClick={() => handleAdd('otras_organizaciones')}>Agregar</Button>
                        </Stack>
                        <ul>
                            {(datos.otras_organizaciones).map((organizacion, index) => (
                                <li key={index} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography>{organizacion.organizaciones}</Typography>
                                    <IconButton onClick={() => removeEl(index, 'otras_organizaciones')}>X</IconButton>
                                </li>
                            ))}
                        </ul>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Typography variant="h6">Resultados de la empresa - socioeconómicos y ambientales</Typography>
                        <Stack direction="row" spacing={2}>
                            <TextField
                                fullWidth
                                value={form.resultados_socioeconomicos}
                                onChange={(e) => setForm({ ...form, resultados_socioeconomicos: e.target.value })}
                                label="Agregar resultado"
                            />
                            <Button variant="contained" onClick={() => handleAdd('resultados_socioeconomicos')}>Agregar</Button>
                        </Stack>
                        <ul>
                            {(datos.resultados_socioeconomicos).map((resultado, index) => (
                                <li key={index} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography>{resultado.resultados}</Typography>
                                    <IconButton onClick={() => removeEl(index, 'resultados_socioeconomicos')}>X</IconButton>
                                </li>
                            ))}
                        </ul>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Typography variant="h6">Perspectivas de desarrollo y beneficios que puede generar la empresa</Typography>
                        <Stack direction="row" spacing={2}>
                            <TextField
                                fullWidth
                                value={form.perspectivas_desarrollo}
                                onChange={(e) => setForm({ ...form, perspectivas_desarrollo: e.target.value })}
                                label="Agregar perspectiva"
                            />
                            <Button variant="contained" onClick={() => handleAdd('perspectivas_desarrollo')}>Agregar</Button>
                        </Stack>
                        <ul>
                            {(datos.perspectivas_desarrollo).map((perspectiva, index) => (
                                <li key={index} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography>{perspectiva.perspectivas}</Typography>
                                    <IconButton onClick={() => removeEl(index, 'perspectivas_desarrollo')}>X</IconButton>
                                </li>
                            ))}
                        </ul>
                    </Grid>

                    <Grid item xs={12}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                            <Button variant="contained" color="success" startIcon={<Save />} onClick={handleUpdate}>Guardar esta sección</Button>
                        </Box>
                    </Grid>
                </Grid>
            ) : (
                <Grid container spacing={2}>
                    {/* Parte no editable */}
                    <Grid item xs={12} md={12}>
                        <Typography variant="h6">Propósitos por los que surgió la empresa</Typography>
                        <Typography sx={{ mx: 1, mt: 2 }}>{datos.propositos_surgimiento}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h6">Factores que han favorecido el desarrollo de la empresa</Typography>
                        <ul>
                            {(datos.factores_desarrollo).map((factor, index) => (
                                <Typography key={index} sx={{ mx: 1, mt: 2 }} component="li">{factor.factores}</Typography>
                            ))}
                        </ul>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h6">Otras Organizaciones que han contribuido al fortalecimiento de la empresa</Typography>
                        <ul>
                            {(datos.otras_organizaciones).map((organizacion, index) => (
                                <Typography key={index} sx={{ mx: 1, mt: 2 }} component="li">{organizacion.organizaciones}</Typography>
                            ))}
                        </ul>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h6">Resultados de la empresa - socioeconómicos y ambientales</Typography>
                        <ul>
                            {(datos.resultados_socioeconomicos).map((resultado, index) => (
                                <Typography key={index} sx={{ mx: 1, mt: 2 }} component="li">{resultado.resultados}</Typography>
                            ))}
                        </ul>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h6">Perspectivas de desarrollo y beneficios que puede generar la empresa</Typography>
                        <ul>
                            {(datos.perspectivas_desarrollo).map((perspectiva, index) => (
                                <Typography key={index} sx={{ mx: 1, mt: 2 }} component="li">{perspectiva.perspectivas}</Typography>
                            ))}
                        </ul>
                    </Grid>
                </Grid>
            )}
        </Box>
    );
};

export default ObjetivosTab;
